import React, { useState } from "react";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PdfPreview from "../../../Common/PDFPreview";
import { formatDate } from "../../../Common/FormatFunctions/FormatDate";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";

const RTGSReport = ({ Slip_No, disabledFeild }) => {
    const API_URL = process.env.REACT_APP_API;
    const apikey = process.env.REACT_APP_API_URL;
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
    const newCompanyName = sessionStorage.getItem("newCompanyName")
    const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")

    const [pdfBlob, setPdfBlob] = useState(null);
    const [apiData, setAPIData] = useState([]);
    const [isBillToShipToSame, setIsBillToShipToSame] = useState(true);

    const fetchData = async () => {
        try {
            const response = await fetch(
                `${API_URL}/getRTGSReport?Company_Code=${companyCode}&Year_Code=${Year_Code}&Slip_No=${Slip_No}`
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            setAPIData(data.all_data);
            generatePdf(data.all_data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const generatePdf = (data) => {
        const allData = data[0];

        const docDate = new Date(allData.Doc_Date);


        const pdf = new jsPDF({ orientation: "portrait" });



        const logoImg = new Image();
        logoImg.src = logo;
        const headerImg = new Image();
        const footerImg1 = new Image();
        headerImg.src = HeaderJK;
        footerImg1.src = FooterJK1
        logoImg.onload = () => {



            let y = 15;

            // ===== HEADER =====
            pdf.setFont("Signika-Bold");
            pdf.setFontSize(18);
            pdf.text(`${allData.Our_Bank || ""}`, 10, y);

            y += 7;
            pdf.setFontSize(14);
            pdf.setFont("Signika-Medium");
            pdf.text(`Branch : ${allData.Our_Branch || ""}`, 10, y);
            pdf.text(
                `Date : ${(allData.Doc_Date || "")}`,
                150,
                y
            );

            pdf.line(10, y + 3, 200, y + 3);

            // ===== BODY =====
            // y += 12;
            // pdf.text(
            //     `Please remit the sum of Rs. ${allData.Amount || 0.00}  (Rs: ${ConvertNumberToWord(
            //         allData.Amount || ""
            //     )})`,
            //     10,
            //     y
            // );

            y += 12;

            const text1 = `Please remit the sum of Rs. ${allData.Amount || 0.00}`;

            // Set normal font
            pdf.setFontSize(14);
            pdf.text(text1, 10, y);

            // Get width of first text
            const textWidth = pdf.getTextWidth(text1);

            // Set smaller font for amount in words
            pdf.setFontSize(11);
            pdf.text(
                `(Rs: ${ConvertNumberToWord(allData.Amount || "")})`,
                10 + textWidth + 2, // place right after first text
                y
            );

            pdf.setFontSize(14);

            y += 8;
            pdf.text(
                `As per details below by debiting our Account No : ${allData.Our_AC_No || 0}`,
                10,
                y
            );



            pdf.line(10, y + 4, 200, y + 4);

            // ===== DETAILS =====
            y += 10;

            const labelX = 10;
            const valueX = 70;
            const rowGap = 7;

            pdf.text("Name of the beneficiary :", labelX, y);
            pdf.setFont("Signika-Bold");
            pdf.text(allData.Party_name || "", valueX, y);

            pdf.setFont("Signika-Regular");
            y += rowGap;
            pdf.text("Destination Bank's Name :", labelX, y);
            pdf.text(allData.Party_Bank || "", valueX, y);

            y += rowGap;
            pdf.text("Branch Name :", labelX, y);
            pdf.text(allData.Party_Branch || "", valueX, y);

            y += rowGap;
            pdf.setFont("Signika-Bold");
            pdf.text("I.F.S.C. :", labelX, y);
            pdf.text(allData.Ifsc || "", valueX, y);

            y += rowGap;
            pdf.text("Account No. :", labelX, y);
            pdf.text(allData.Party_Ac_No || "", valueX, y);

            // ===== AMOUNT SECTION =====
            y += 10;
            pdf.text(`Amount :`, labelX, y);
            pdf.text(allData.Amount || 0.00, valueX, y);
            const amt = `${allData.Amount || 0.00}`

            y += 10;
            pdf.text(`Amount In Words:`, labelX, y);
            pdf.setFont("Signika-Regular");
            const totalInWords = ConvertNumberToWord(
                (amt)
            );
            pdf.text(`${totalInWords}.`, valueX, y);
            // pdf.text(`(Rupees ${formatReadableAmount(allData.Amount)})`, valueX, y);


            y += rowGap;
            pdf.text(`Charges : ${allData.Charges}`, labelX, y);

            y += rowGap;
            pdf.text(`Total   : ${allData.Total}`, labelX, y);

            // ===== FOOTER =====
            y += 10;
            pdf.line(10, y - 5, 200, y - 5);

            y += 8;
            pdf.text(`Cheque No : ${allData.cheque_No}`, 10, y);
            pdf.text(`Challan No : ${allData.Challan_No}`, 120, y);

            y += rowGap;
            pdf.text(`UTR No : ${allData.UTR_No}`, 10, y);

            y += 20;
            pdf.setFont("Signika-Bold");
            pdf.text("Signature", 160, y);

            // pdf.setFontSize(9);


            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfBlob(pdfUrl);
        };
    };

    return (
        <div id="pdf-content">
            {pdfBlob && (
                <PdfPreview pdfData={pdfBlob} apiData={apiData[0]} label={"UTR"} />
            )}
            {/* <button onClick={fetchData} className="print-button" disabled={disabledFeild}>Print</button> */}
            <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} />
        </div>
    );
};

export default RTGSReport;